import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { VehicleModel } from 'client/data/models/vehicle-v2';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { EdmundsLandingDecorator } from 'site-modules/shared/pages/decorators/edmunds-landing-decorator';
import { Indexred } from './indexred';

export const PageDefinitionConfiguration = {
  name: 'other_affiliate_index',
  category: 'other',
  preload: store => {
    const preloader = new ModelPreloader(store);

    preloader.resolve('makesList', VehicleModel);

    return preloader.load();
  },
  seo: {
    robots: {
      noFollow: true,
      noIndex: true,
    },
  },
  component: Indexred,
  decorator: EdmundsLandingDecorator,
};

export default pageDefinition(PageDefinitionConfiguration);
